(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));

  const drawer = $('#CartDrawer');
  const overlay = $('.drawer-overlay');
  const menu = $('.mobile-menu');
  const menuOverlay = $('.mobile-menu-overlay');
  const searchModal = $('[data-search-modal]');

  function openDrawer() {
    drawer?.classList.add('open'); overlay?.classList.add('open');
    drawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open');
    $('[data-drawer-close]', drawer)?.focus();
  }
  function closeDrawer() {
    drawer?.classList.remove('open'); overlay?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open');
  }
  function openMenu() {
    menu?.classList.add('open'); menuOverlay?.classList.add('open');
    menu?.setAttribute('aria-hidden', 'false'); document.body.classList.add('menu-open');
  }
  function closeMenu() {
    menu?.classList.remove('open'); menuOverlay?.classList.remove('open');
    menu?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('menu-open');
  }
  function openSearch() {
    searchModal?.classList.add('open'); searchModal?.setAttribute('aria-hidden', 'false');
    setTimeout(() => $('[data-predictive-search]')?.focus(), 30);
  }
  function closeSearch() { searchModal?.classList.remove('open'); searchModal?.setAttribute('aria-hidden', 'true'); }

  $$('[data-cart-open]').forEach(button => button.addEventListener('click', async () => { await refreshCart(); openDrawer(); }));
  $$('[data-drawer-close]').forEach(button => button.addEventListener('click', closeDrawer));
  $('[data-menu-open]')?.addEventListener('click', openMenu);
  $$('[data-menu-close]').forEach(button => button.addEventListener('click', closeMenu));
  $$('[data-search-open]').forEach(button => button.addEventListener('click', openSearch));
  $('[data-search-close]')?.addEventListener('click', closeSearch);
  searchModal?.addEventListener('click', event => { if (event.target === searchModal) closeSearch(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeDrawer(); closeMenu(); closeSearch(); } });

  async function request(url, options = {}) {
    const response = await fetch(url, { headers: { Accept: 'application/json', ...options.headers }, ...options });
    if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || 'Store request failed.');
    return response.json();
  }

  function cartHtml(cart) {
    if (!cart.items.length) return '<div class="cart-empty">Your cart is empty.<br><a href="/collections/all">Explore our research catalog.</a></div>';
    return cart.items.map(item => `<div class="cart-item" data-key="${escapeHtml(item.key)}">
      ${item.image ? `<img src="${escapeHtml(item.image)}&width=140" alt="${escapeHtml(item.product_title)}">` : ''}
      <div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a><small>${escapeHtml(item.variant_title || '')}</small><div class="qty-stepper" data-qty-stepper><button type="button" class="qty-btn" data-qty-down="${escapeHtml(item.key)}" aria-label="Decrease quantity">−</button><input class="qty-input" type="number" inputmode="numeric" min="0" step="1" value="${item.quantity}" data-qty-input="${escapeHtml(item.key)}" aria-label="Quantity"><button type="button" class="qty-btn" data-qty-up="${escapeHtml(item.key)}" aria-label="Increase quantity">+</button></div><button class="remove-link" data-remove-key="${escapeHtml(item.key)}">Remove</button></div><b>${formatMoney(item.final_line_price)}</b></div>`).join('');
  }

  // Patch the drawer rows in place when the SET of lines is unchanged, for the
  // same reason renderCartPage does: a full innerHTML rebuild destroys the
  // stepper being clicked and steals focus from an input being typed into.
  // Returns false when the structure changed and a full re-render is required.
  function patchDrawerInPlace(cart) {
    const body = $('[data-cart-body]');
    if (!body) return false;
    const rows = body.querySelectorAll('.cart-item');
    if (!rows.length || rows.length !== cart.items.length) return false;
    // Keyed by VARIANT for the same reason as renderCartPage: line keys rotate
    // on every write, so key equality would spuriously force a full rebuild
    // (which destroys the stepper mid-click).
    const byVariant = new Map(cart.items.map(i => [String(i.key).split(':')[0], i]));
    for (const row of rows) {
      const item = byVariant.get(String(row.dataset.key).split(':')[0]);
      if (!item) return false;                 // different lines -> full render
      if (row.dataset.key !== item.key) rekeyLine(row.dataset.key, item.key);
      const price = row.querySelector('b');
      if (price) price.textContent = formatMoney(item.final_line_price);
      const input = row.querySelector('[data-qty-input]');
      if (input && document.activeElement !== input && !qtyPending.has(item.key)) {
        input.value = item.quantity;
      }
    }
    return true;
  }

  async function refreshCart() {
    const cart = await request('/cart.js');
    const body = $('[data-cart-body]'); const footer = $('[data-cart-footer]');
    if (body && !patchDrawerInPlace(cart)) body.innerHTML = cartHtml(cart);
    if (footer) footer.hidden = cart.items.length === 0;
    $('[data-cart-total]') && ($('[data-cart-total]').textContent = formatMoney(cart.total_price));
    $$('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
    const checkbox = $('[data-attestation]');
    if (checkbox) checkbox.checked = cart.attributes?.research_attestation === 'confirmed';
    syncCheckoutButton();
    return cart;
  }

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[action*="/cart/add"], .quick-add, #ProductForm');
    if (!form) return;
    event.preventDefault();
    const submit = $('button[type="submit"]', form); const original = submit?.textContent;
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    try {
      await request('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      await refreshCart(); openDrawer();
    } catch (error) { alert(error.message); }
    finally { if (submit) { submit.disabled = false; submit.textContent = original; } }
  });

  document.addEventListener('click', async event => {
    const remove = event.target.closest('[data-remove-key]');
    if (!remove) return;
    remove.disabled = true;
    try { await request('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.removeKey, quantity: 0 }) }); await refreshCart(); }
    catch (error) { alert(error.message); }
  });

  // ---- Cart quantity editing -------------------------------------------------
  // Shopify does NOT auto-add a BOGO free item: the customer must physically
  // carry qty 3 to earn "buy 2 get 1". Editing quantity was previously only
  // possible by removing the line and re-adding from the PDP, so this is the
  // load-bearing control for any quantity-based promotion.
  //
  // setLineQuantity is the single writer for both the drawer and the cart page.
  // /cart/change.js is authoritative: it CLAMPS to available stock rather than
  // erroring, so the response can disagree with what the shopper typed. We
  // always re-render from the response instead of trusting the input value.
  //
  // 🔴 Clicks must be COALESCED, never DROPPED. The first version of this used a
  // simple in-flight boolean and returned early while a request was open. QA:
  // five clicks 120ms apart on a ~400ms round trip landed on qty 2 instead of 6
  // -- four silently discarded. That is precisely the shopper trying to reach 3
  // for a buy-2-get-1, so it would have broken the promotion it exists to serve.
  //
  // Now: the input updates OPTIMISTICALLY on every click, and the pending target
  // is overwritten while a request is open, then flushed when it completes.
  // Last-write-wins, no lost clicks, still exactly one request in flight.
  const qtyPending = new Map();   // key -> desired quantity not yet sent
  const qtyBusy = new Set();      // keys with a request currently open

  function paintQuantity(key, value) {
    document.querySelectorAll(`[data-qty-input="${CSS.escape(key)}"]`).forEach(input => {
      input.value = value;
    });
  }

  function setLineQuantity(key, quantity) {
    const wanted = Math.max(0, Math.floor(Number(quantity) || 0));
    paintQuantity(key, wanted);          // immediate feedback, no waiting on the network
    qtyPending.set(key, wanted);
    if (qtyBusy.has(key)) return null;   // a flush is already running; it will pick this up
    return flushLineQuantity(key);
  }

  //
  // 🔴 THE LINE KEY IS NOT STABLE. Shopify mints a NEW key for the line on every
  // successful /cart/change.js call (observed 44076217532503:949269... ->
  // 44076217532503:65d5f3... on a single update). Reusing the key we started
  // with makes the SECOND queued request fail with
  //     400 {"status":"bad_request","message":"no valid id or line parameter"}
  // which is exactly why rapid clicking stalled at qty 2. So after each write we
  // re-resolve the line by VARIANT ID from the response and continue with the
  // fresh key -- and we migrate the pending entry and the DOM attributes onto it.
  //
  async function flushLineQuantity(key) {
    let activeKey = key;
    qtyBusy.add(activeKey);
    let cart = null;
    try {
      while (qtyPending.has(activeKey)) {
        const wanted = qtyPending.get(activeKey);
        qtyPending.delete(activeKey);
        const variantId = String(activeKey).split(':')[0];
        cart = await pushLineQuantity(activeKey, wanted);
        if (!cart) break;
        const line = cart.items.find(i => String(i.key).split(':')[0] === variantId);
        const freshKey = line ? line.key : null;
        if (freshKey && freshKey !== activeKey) {
          rekeyLine(activeKey, freshKey);
          if (qtyPending.has(activeKey)) {
            qtyPending.set(freshKey, qtyPending.get(activeKey));
            qtyPending.delete(activeKey);
          }
          qtyBusy.delete(activeKey);
          activeKey = freshKey;
          qtyBusy.add(activeKey);
        }
      }
    } finally {
      qtyBusy.delete(activeKey);
    }
    return cart;
  }

  // Point every DOM hook at the line's new key so the next click targets a key
  // the cart still recognises.
  function rekeyLine(oldKey, newKey) {
    const sel = CSS.escape(oldKey);
    document.querySelectorAll(`[data-qty-input="${sel}"]`).forEach(el => { el.dataset.qtyInput = newKey; });
    document.querySelectorAll(`[data-qty-up="${sel}"]`).forEach(el => { el.dataset.qtyUp = newKey; });
    document.querySelectorAll(`[data-qty-down="${sel}"]`).forEach(el => { el.dataset.qtyDown = newKey; });
    document.querySelectorAll(`[data-remove-key="${sel}"]`).forEach(el => { el.dataset.removeKey = newKey; });
    document.querySelectorAll(`.cart-item[data-key="${sel}"], .cart-page-item[data-key="${sel}"]`).forEach(el => { el.dataset.key = newKey; });
  }

  async function pushLineQuantity(key, wanted) {
    document.querySelectorAll('[data-qty-stepper]').forEach(s => s.classList.add('is-busy'));
    try {
      const cart = await request('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: wanted })
      });
      const line = cart.items.find(i => i.key === key);
      const granted = line ? line.quantity : 0;
      // Only reconcile the visible number when nothing newer is queued --
      // otherwise a slow response would stomp a fresher click.
      if (!qtyPending.has(key) && granted !== wanted) paintQuantity(key, granted);
      if (granted !== wanted) {
        // Stock clamp. Say so plainly rather than silently showing a number
        // the shopper did not choose. Flag EVERY copy of the line (drawer and
        // cart page both render it), not just the first in the document.
        document.querySelectorAll(`[data-qty-input="${CSS.escape(key)}"]`).forEach(input => {
          input.classList.add('qty-clamped');
          setTimeout(() => input.classList.remove('qty-clamped'), 1600);
        });
        if (wanted > 0 && granted < wanted) {
          announce(`Only ${granted} available — quantity set to ${granted}.`);
        }
      }
      // Skip the expensive re-render while more clicks are queued; the final
      // pass through the loop paints the settled state.
      if (!qtyPending.has(key)) {
        if (document.querySelector('[data-cart-lines]')) renderCartPage(cart);
        await refreshCart();
      }
      return cart;
    } catch (error) {
      qtyPending.delete(key);
      alert(error.message);
      await refreshCart();
      return null;
    } finally {
      document.querySelectorAll('[data-qty-stepper]').forEach(s => s.classList.remove('is-busy'));
    }
  }

  function announce(message) {
    let region = $('#CartLiveRegion');
    if (!region) {
      region = document.createElement('p');
      region.id = 'CartLiveRegion';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = message;
  }

  // Cart PAGE lines re-render in place so the row price and subtotal move with
  // the stepper. The <form> and its "Update cart" button stay in the markup as
  // a no-JS fallback.
  //
  // 🔴 Updates the cart page IN PLACE. An earlier version rebuilt the whole list
  // with innerHTML on every change; QA showed only 2 of 5 rapid clicks ever
  // reached the document, because each re-render DESTROYED the very button
  // being clicked and the remaining clicks landed on detached nodes. Same
  // hazard for a shopper mid-type: replacing the input drops focus and caret.
  // Only the numbers that actually change are touched now; the row elements,
  // focus and caret all survive.
  //
  function renderCartPage(cart) {
    const lines = $('[data-cart-lines]');
    if (!lines) return;
    // 🔴 NO location.reload() ANYWHERE IN THIS PATH. An earlier version reloaded
    // as a "safe fallback" for an empty cart or a missing row. QA proved it is
    // the opposite of safe: a reload during rapid clicking tore down the
    // document mid-sequence, so 5 clicks produced qty 3 and the remaining
    // clicks hit a dead page. A quantity change must never navigate.
    if (!cart.items.length) {
      lines.innerHTML = '<p class="cart-empty">Your cart is empty. <a href="/collections/all">Browse the catalog.</a></p>';
      const emptyTotal = $('[data-cart-page-total]');
      if (emptyTotal) emptyTotal.textContent = formatMoney(0);
      $('.cart-summary')?.setAttribute('hidden', '');
      return;
    }

    // 🔴 Match rows by VARIANT, not by line key. Shopify re-mints the line key on
    // every write, so a key-equality check deletes the row it was supposed to
    // update -- that is what emptied the cart page mid-click during QA even
    // though the server state was correct (qty 6, zero rows on screen).
    const seenVariants = new Set();
    cart.items.forEach(item => {
      const variant = String(item.key).split(':')[0];
      seenVariants.add(variant);
      const row = lines.querySelector(`.cart-page-item[data-key="${CSS.escape(item.key)}"]`)
        || Array.from(lines.querySelectorAll('.cart-page-item'))
             .find(r => String(r.dataset.key).split(':')[0] === variant);
      if (!row) return;   // line added elsewhere; the drawer stays authoritative
      if (row.dataset.key !== item.key) rekeyLine(row.dataset.key, item.key);
      const price = row.querySelector('b');
      if (price) price.textContent = formatMoney(item.final_line_price);
      const input = row.querySelector('[data-qty-input]');
      // Never clobber a field the shopper is actively editing.
      if (input && document.activeElement !== input && !qtyPending.has(item.key)) {
        input.value = item.quantity;
      }
    });
    // Drop rows genuinely removed (qty 0, or the drawer's Remove link).
    lines.querySelectorAll('.cart-page-item').forEach(row => {
      if (!seenVariants.has(String(row.dataset.key).split(':')[0])) row.remove();
    });

    const subtotal = $('[data-cart-page-total]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  document.addEventListener('click', async event => {
    const up = event.target.closest('[data-qty-up]');
    const down = event.target.closest('[data-qty-down]');
    if (!up && !down) return;
    event.preventDefault();
    const button = up || down;
    const key = up ? up.dataset.qtyUp : down.dataset.qtyDown;
    // 🔴 The cart PAGE also renders the drawer, so the same line key exists
    // TWICE in the DOM. A document-wide querySelector returns whichever comes
    // first in source order, which is not necessarily the stepper the shopper
    // clicked -- if the two ever disagree, + would step from the wrong number.
    // Read from the stepper that OWNS the clicked button instead.
    const input = button.closest('[data-qty-stepper]')?.querySelector('[data-qty-input]');
    // Step from the QUEUED target when one exists, so rapid clicks accumulate
    // (1,2,3...) instead of all reading the same stale on-screen value.
    const current = qtyPending.has(key) ? qtyPending.get(key) : (Number(input?.value) || 0);
    const next = up ? current + 1 : current - 1;
    if (next < 0) return;
    setLineQuantity(key, next);
  });

  // Commit typed values on blur / Enter, not on every keystroke -- firing per
  // keystroke makes "10" transit through 1 and races the network.
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-qty-input]');
    if (!input) return;
    setLineQuantity(input.dataset.qtyInput, input.value);
  });
  document.addEventListener('keydown', event => {
    const input = event.target.closest('[data-qty-input]');
    if (input && event.key === 'Enter') { event.preventDefault(); input.blur(); }
  });

  function syncCheckoutButton() {
    const checkbox = $('[data-attestation]'); const checkout = $('[data-checkout]');
    if (!checkout || !checkbox) return;
    checkout.disabled = !checkbox.checked;
    checkout.textContent = checkbox.checked ? 'Proceed to Checkout' : 'Confirm attestation to continue';
  }
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-attestation]')) {
      syncCheckoutButton();
      try { await request('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { research_attestation: event.target.checked ? 'confirmed' : '' } }) }); }
      catch (error) { event.target.checked = false; syncCheckoutButton(); alert(error.message); }
    }
    if (event.target.matches('[data-sort-select]')) { const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); location.assign(url); }
    if (event.target.matches('.variant-option input')) {
      $('[data-product-price]') && ($('[data-product-price]').textContent = event.target.dataset.price);
      const submit = $('#ProductForm button[type="submit"]'); if (submit) submit.textContent = `Add to Cart — ${event.target.dataset.price}`;
    }
  });
  $('[data-checkout]')?.addEventListener('click', () => { if ($('[data-attestation]')?.checked) location.assign('/checkout'); });

  // Related products ("Pairs well with"). The section server-renders a
  // same-collection fallback so it is never empty. Here we ask Shopify's
  // Product Recommendations API for something better and swap it in ONLY if it
  // actually returns cards -- an empty engine response leaves the fallback alone.
  const relatedMount = $('.related-products-mount');
  if (relatedMount && relatedMount.dataset.url) {
    const relatedSection = relatedMount.closest('[data-related-section]') || relatedMount;
    fetch(relatedMount.dataset.url)
      .then(response => (response.ok ? response.text() : Promise.reject(new Error('recommendations unavailable'))))
      .then(text => {
        const markup = new DOMParser().parseFromString(text, 'text/html');
        const grid = markup.querySelector('.product-grid');
        if (grid && grid.children.length) relatedSection.replaceWith(...markup.body.childNodes);
        else relatedMount.remove();
      })
      .catch(() => relatedMount.remove());
  }

  // ---------------------------------------------------------------------------
  // Volume pricing (peptides meeting 2026-08-05).
  //   Phiton: "once you click up in the quantities, it should automatically drop
  //            the price"
  //   Ken:    "I should probably show the discount too"
  //
  // Repriced entirely from the tier ladder the PDP already renders (Ken's pricing
  // sheet -> uspl.volume_tiers metafield -> data-volume-tiers). No prices are
  // computed or invented here: every figure displayed is read out of that payload,
  // so the page can never quote a number the sheet does not contain.
  //
  // Applies to the DISPLAYED unit price, the Add to Cart label and the tier table
  // highlight. It does NOT create the cart discount -- that is an app/Admin
  // automatic discount, and the closing note in the panel is gated on the
  // `volume_discount_automatic` theme setting so the copy cannot over-promise.
  // ---------------------------------------------------------------------------
  const tierPanel = $('[data-volume-tiers]');
  if (tierPanel) {
    let ladder = [];
    try { ladder = JSON.parse(tierPanel.dataset.volumeTiers || '[]'); } catch (_) { ladder = []; }

    // 🔴 CATALOG-AWARE PRICING. The store runs market catalogs (Wholesale -56%,
    // VIP -41%). The sheet below (uspl.volume_tiers) holds ABSOLUTE RETAIL
    // dollars and knows nothing about catalogs, so painting its numbers onto
    // the page showed a wholesale customer $100.00 retail while checkout
    // charged them $44.00 -- their whole discount was invisible.
    //
    // Liquid's variant.price IS catalog-aware, so we take the LIVE price as the
    // source of money and use the sheet only for the LADDER (which breaks, and
    // the ratio at each). On the retail catalog the ratio is 1:1, so retail
    // shoppers see exactly what they saw before.
    let livePrices = {};
    try { livePrices = JSON.parse(tierPanel.dataset.livePrices || '{}'); } catch (_) { livePrices = {}; }

    // Live unit price (cents) for a ladder row, falling back to the sheet's
    // retail figure if the variant title isn't in the map.
    function liveRetailFor(row) {
      const live = livePrices[row.variant];
      if (typeof live === 'number') return live;
      // Single-variant products are titled "Default Title" in Liquid and will
      // never match the sheet's label, so fall back to the selected variant's
      // live price before falling back to the (catalog-blind) sheet figure.
      const selected = livePrices.__selected;
      if (typeof selected === 'number') return selected;
      return row.retail;
    }

    // Scale a sheet tier onto the live catalog price. Guard the divisor so a
    // zero/missing retail figure can never produce $0.00 or NaN on a live page.
    function tierPrice(row, tierBreak) {
      const sheetUnit = row[keyFor(tierBreak)];
      if (typeof sheetUnit !== 'number') return null;
      const liveRetail = liveRetailFor(row);
      if (!row.retail || row.retail <= 0) return sheetUnit;
      if (liveRetail === row.retail) return sheetUnit;   // retail catalog: identity
      return Math.round(liveRetail * sheetUnit / row.retail);
    }

    const qtyInput = $('#ProductForm [name="quantity"]');
    const priceEl = $('[data-product-price]');
    const submitEl = $('#ProductForm button[type="submit"]');
    const basePrice = priceEl?.textContent.trim();

    // Ladder moved 1/3/6/10 -> 1/2/5 on 2026-08-19. Derive the breaks from the keys
    // actually present in the metafield rather than hardcoding them again: the sheet
    // owns the ladder, and a hardcoded list silently mismatches the table the moment
    // it moves (this line was the last place still asserting 3/6/10).
    const BREAKS = [...new Set(ladder.flatMap(row =>
      Object.keys(row).filter(k => /^buy\d+$/.test(k)).map(k => parseInt(k.slice(3), 10))
    ))].sort((a, b) => b - a);
    const breakFor = qty => BREAKS.find(b => qty >= b) || 1;
    const keyFor = tierBreak => (tierBreak === 1 ? 'retail' : `buy${tierBreak}`);

    // Match the tier row to the selected variant. Single-variant products have one
    // row; multi-variant products key on the variant title as written in the sheet.
    function activeRow() {
      if (ladder.length === 1) return ladder[0];
      const checked = $('.variant-option input:checked');
      const label = checked?.closest('.variant-option')?.querySelector('span')?.textContent || '';
      return ladder.find(row => label.includes(row.variant)) || ladder[0];
    }

    function applyTier() {
      if (!ladder.length) return;
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      const tierBreak = breakFor(qty);
      const row = activeRow();
      const unit = row ? tierPrice(row, tierBreak) : null;

      $$('.tier-chip', tierPanel).forEach(chip => {
        chip.classList.toggle('is-active', Number(chip.dataset.tierQty) === tierBreak);
      });
      $$('[data-tier-row]', tierPanel).forEach(tr => {
        const isActiveRow = !row || tr.dataset.tierRow === row.variant;
        tr.classList.toggle('is-active-row', isActiveRow && ladder.length > 1);
        $$('[data-tier-cell]', tr).forEach(td => {
          td.classList.toggle('is-active-cell', isActiveRow && Number(td.dataset.tierCell) === tierBreak);
        });
      });

      if (typeof unit !== 'number') return;
      // Compare against the LIVE unit price, not the sheet's retail, or a
      // wholesale customer would be shown a fabricated "saving" measured from
      // a price they never pay.
      const saved = liveRetailFor(row) - unit;
      if (priceEl) {
        // The struck-through "was" price must be the shopper's OWN unit price at
        // qty 1 (liveRetailFor), never the sheet's retail figure. On a wholesale
        // catalog those differ: showing row.retail printed "$39.60 was $100.00
        // Save $22.00" -- a strikethrough they never pay, next to a saving
        // computed from $44. Same source for both, or the maths visibly lies.
        priceEl.innerHTML = tierBreak === 1
          ? formatMoney(unit)
          : `${formatMoney(unit)} <small class="price-was">${formatMoney(liveRetailFor(row))}</small> <span class="price-save">Save ${formatMoney(saved * qty)}</span>`;
      }
      if (submitEl && !submitEl.disabled) {
        submitEl.textContent = qty > 1
          ? `Add ${qty} to Cart — ${formatMoney(unit * qty)}`
          : `Add to Cart — ${formatMoney(unit)}`;
      }
    }

    // Clicking a break chip sets the quantity to that break -- the whole point is
    // one tap to reach the discount (Ken wanted the breaks low enough that "they
    // fucking get to that three no problem").
    $$('.tier-chip', tierPanel).forEach(chip => chip.addEventListener('click', () => {
      if (qtyInput) { qtyInput.value = chip.dataset.tierQty; }
      applyTier();
    }));
    qtyInput?.addEventListener('input', applyTier);
    qtyInput?.addEventListener('change', applyTier);
    // Variant radios are handled by the generic change listener above, which resets
    // the price to the variant base; re-run after it so the tier survives a switch.
    document.addEventListener('change', event => {
      if (event.target.matches('.variant-option input')) setTimeout(applyTier, 0);
    });
    if (basePrice) applyTier();
  }

  let searchTimer;
  $('[data-predictive-search]')?.addEventListener('input', event => {
    clearTimeout(searchTimer); const query = event.target.value.trim(); const results = $('[data-predictive-results]');
    if (!query) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const data = await request(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map(product => `<a class="predictive-item" href="${escapeHtml(product.url)}">${product.image ? `<img src="${escapeHtml(product.image)}&width=96" alt="">` : ''}<span><strong>${escapeHtml(product.title)}</strong><small>${escapeHtml(product.type || 'Research product')}</small></span></a>`).join('') : '<p>No product results.</p>';
      } catch (_) { results.innerHTML = '<p>Search is temporarily unavailable.</p>'; }
    }, 180);
  });
})();

/* ---------- Wholesale application submit (page.wholesale) ----------
   Posts multipart/form-data (including the license upload) to the Worker
   endpoint. Shopify's native contact form cannot carry a file, which is why
   this page does not use it. The general contact form is untouched.
------------------------------------------------------------------- */
(function () {
  var form = document.getElementById('wholesaleApplication');
  if (!form) return;

  var alertBox = document.getElementById('wsAlert');
  var submitBtn = form.querySelector('.ws-submit');
  var MAX_BYTES = 10 * 1024 * 1024;

  function showAlert(kind, msg) {
    alertBox.className = 'ws-alert is-' + kind;
    alertBox.innerHTML = msg;
    alertBox.hidden = false;
    alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearFieldErrors() {
    form.querySelectorAll('.has-error').forEach(function (el) {
      el.classList.remove('has-error');
    });
    form.querySelectorAll('.ws-field-error').forEach(function (el) {
      el.remove();
    });
  }

  function markField(name, message) {
    var field = form.querySelector('[name="' + name + '"]');
    if (!field) return;
    var label = field.closest('label') || field.parentElement;
    label.classList.add('has-error');
    if (message) {
      var note = document.createElement('small');
      note.className = 'ws-field-error';
      note.textContent = message;
      label.appendChild(note);
    }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    clearFieldErrors();
    alertBox.hidden = true;

    var endpoint = form.dataset.endpoint;
    if (!endpoint) {
      showAlert('error',
        'This form is not yet connected. Please email ' +
        '<a href="mailto:help@uspeptidelabs.co">help@uspeptidelabs.co</a>.');
      return;
    }

    // client-side checks that mirror the server's, for fast feedback only —
    // the server revalidates everything and is the authority
    var invalid = [];
    form.querySelectorAll('[required]').forEach(function (el) {
      var ok = el.type === 'checkbox' ? el.checked : String(el.value || '').trim() !== '';
      if (!ok) invalid.push([el.name, 'Required.']);
    });
    var fileInput = form.querySelector('[name="license_file"]');
    if (fileInput && fileInput.files && fileInput.files[0]) {
      if (fileInput.files[0].size > MAX_BYTES) {
        invalid.push(['license_file', 'File is larger than 10 MB.']);
      }
    }
    if (invalid.length) {
      invalid.forEach(function (pair) { markField(pair[0], pair[1]); });
      showAlert('error', 'Please correct the highlighted field' +
        (invalid.length > 1 ? 's' : '') + ' and try again.');
      return;
    }

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Submitting…';

    var data = new FormData(form);
    var token = form.querySelector('[name="cf-turnstile-response"]');
    if (token) data.append('turnstile_token', token.value);

    fetch(endpoint, { method: 'POST', body: data })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (result) {
        if (result.ok) {
          form.reset();
          showAlert('success',
            '<strong>Application received.</strong> Our team will review it within ' +
            '1–2 business days and contact you at the email you provided.');
          submitBtn.textContent = 'Submitted';
          return;
        }
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (result.body && result.body.errors) {
          Object.keys(result.body.errors).forEach(function (k) {
            markField(k, result.body.errors[k]);
          });
          showAlert('error', 'Please correct the highlighted fields and try again.');
        } else if (result.status === 429) {
          showAlert('error', 'Too many submissions. Please try again later.');
        } else {
          showAlert('error',
            'Something went wrong submitting your application. Please email ' +
            '<a href="mailto:help@uspeptidelabs.co">help@uspeptidelabs.co</a>.');
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        showAlert('error',
          'Network error. Please check your connection, or email ' +
          '<a href="mailto:help@uspeptidelabs.co">help@uspeptidelabs.co</a>.');
      });
  });
})();
